import React from 'react';
// import { Provider } from 'react-redux';
// import { store, history } from './redux/store';
// import PublicRoutes from './router';
// import { ThemeProvider } from 'styled-components';
// import { LocaleProvider } from 'antd';
// import { IntlProvider } from 'react-intl';
// import themes from './config/themes';
import AppLocale from './languageProvider';
import config, {
  getCurrentLanguage
} from './containers/LanguageSwitcher/config';
// import { themeConfig } from './config';
// import DashAppHolder from './dashAppStyle';
// import 'antd/dist/antd.css';

const currentAppLocale =
  AppLocale[getCurrentLanguage(config.defaultLanguage || 'english').locale];

export { AppLocale };



// WEBPACK FOOTER //
// ./src/dashApp.js